import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  text-align: left;
  padding: 18px 24px 22px 24px;

  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2 {
      color: var(--grey-0);
      font-size: 22px;
      font-weight: 600;
      line-height: 1.1;
    }

    .close {
      transform: translateX(15px);
    }
  }

  textarea.feedback-text {
    background: var(--menu-color-fullscreen);
    color: var(--grey-0);
    width: calc(100% - 40px);
    resize: none;
    border-radius: 10px;
    border: 1.5px solid var(--primary-cta-high-contrast);
    padding: 20px;
    font-size: 16px;
    font-family: "Inter";
    font-weight: 500;
    line-height: 1.1;
    margin-bottom: 20px;
    height: 200px;
  }

  .footer-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .success {
      font-weight: 500;
      color: var(--grey-0);

      &.hidden {
        opacity: 0;
      }
    }

    button {
      font-size: 16px;
      background: var(--primary-cta);
      color: var(--cta-text-color);
      border: 0;
      border-radius: 9px;
      font-family: Inter;
      font-weight: 500;
      padding: 11px;
      cursor: pointer;

      &:disabled {
        background: var(--grey-2) !important;
      }
    }
  }
`;
